import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { useSmartviewManager } from '@morningtrain/react-smartviews'

function SmartviewSidebar (props) {
  const smartviewManager = useSmartviewManager()
  const wrapperRef = React.createRef()
  const innerWrapperRef = React.createRef()

  const handleClickOutside = (event) => {
    if (props.ghost === true) {
      return
    }

    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      smartviewManager.handleClickOutside()
    }
  }

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  const currentSize = smartviewManager.config.get('size')
  const [size, setSize] = React.useState()

  React.useEffect(() => {
    if (size !== currentSize) {
      setSize(currentSize)
    }
  })

  const innerWrapperClassNames = [
    'transform',
    'transition-width',
    'ease-in-out',
    'duration-500',
    'sm:duration-700'
  ]

  const innerWrapperClassName = innerWrapperClassNames.join(' ')

  React.useEffect(() => {
    const element = innerWrapperRef.current

    if (element) {
      const sizeClass = 'w-' + currentSize
      const innerWrapperClassNameWithSize = innerWrapperClassName + ' ' + sizeClass

      if (element.className !== innerWrapperClassNameWithSize) {
        if (innerWrapperRef.current.classList && innerWrapperRef.current.classList.add) {
          ([].slice.call(innerWrapperRef.current.classList)).forEach(className => {
            if (innerWrapperClassNames.indexOf(className) === -1) {
              innerWrapperRef.current.classList.remove(className)
            }
          })

          innerWrapperRef.current.classList.add(sizeClass)
        } else {
          innerWrapperRef.current.className = innerWrapperClassNameWithSize
        }
      }
    }
  }, [size])

  return (
    <section ref={wrapperRef} className={(props.ghost === true ? 'relative' : 'absolute') + ' inset-y-0 right-0 max-w-full flex'}>
      <div ref={innerWrapperRef} className={innerWrapperClassName}>
        <div className='h-full flex flex-col py-8 bg-white overflow-y-auto sm:py-12'>
          {props.children}
        </div>
      </div>
    </section>
  )
};

SmartviewSidebar.defaultProps = {
  ghost: false
}

SmartviewSidebar.propTypes = {
  ghost: PropTypes.bool
}

export default observer(SmartviewSidebar)
